import { useQuery } from '@tanstack/react-query';
import type { API } from '@trinity/chat';
import { useChatApiClient } from '@trinity/chat-components/containers/Chat/useApiClient.js';
import { useActiveBrandIdentifier } from '@trinity/chat-components/containers/UserBrands/useActiveBrandIdentifier';
import { useDebounceValue } from '@trinity/chat-components/hooks/useDebounceValue';

type Props = {
  enabled?: boolean;
  excluded: (number | string)[];
  type: API.Chat.SearchChatFilters.SearchField;
  value: string;
  brandIdentifier: string;
};

export const useFilterSearchQuery = ({
  enabled = true,
  ...props
}: Props) => {

  const debouncedProps = useDebounceValue(props, 300);
  const brandIdentifier = useActiveBrandIdentifier();

  const queryProps = {
    ...debouncedProps,
    brandIdentifier,
  };

  const apiClient = useChatApiClient();

  return useQuery({
    queryKey: ['get:chat/filters', queryProps],
    queryFn: ({ queryKey: [_, data] }) => {
      return apiClient.chat.searchChatFilters(data as Props);
    },
    refetchOnWindowFocus: false,
    placeholderData: (prevData) => prevData ?? { results: [] },
    enabled,
  });
};